import { call, put, takeLatest } from 'redux-saga/effects';
import { getStoreAndGrades } from '../../../services/common/selectList.service';
import getSummary from '../../../services/visit/dailyVisitStatus.service';
import {
  ACTION_TYPE,
  actCallApiGetSelectListSuccess,
  actCallApiGetDailyVisitStatusSuccess,
} from './action';
import { actCallApiServerError } from '../../common/common/action';

/**
 * 店舗と会員グレード取得
 * @param {*} param0
 */
function* callApiGetStoreAndGrade() {
  try {
    const selects = yield call(getStoreAndGrades);
    yield put(actCallApiGetSelectListSuccess(selects));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * 日別サマリを取得
 * @param {*} param0
 */
function* callApiGetSummary({ param }) {
  try {
    const datas = yield call(getSummary, param);
    yield put(actCallApiGetDailyVisitStatusSuccess(datas));
  } catch (error) {
    yield put(actCallApiServerError(error));
  }
}

/**
 * Export default root saga
 * @returns {IterableIterator<boolean>}
 */
export default function* watchCallDailyVisitStatus() {
  yield takeLatest(ACTION_TYPE.CALL_API_GET_DAILY_VISIT_STATUS_SELECT, callApiGetStoreAndGrade);
  yield takeLatest(ACTION_TYPE.CALL_API_GET_DAILY_VISIT_STATUS, callApiGetSummary);
}
